import React from 'react'

import { ButtonLink } from '@/legacy-src/components/ui/button'

import { type ButtonPropTypes } from '../button/Button'
import GenericAddQueryToHref from './GenericQueryForwarding'

type Props = Omit<ButtonPropTypes, 'href'> & { href: string }

// this button is used mostly for webviews in app,
// where we need to keep the hideUi query param in the url
// this creates the problem with static rendering, so we need to use suspense
const ButtonWithQueryForwarding: React.FC<Props> = (props) => {
  return (
    <GenericAddQueryToHref {...props}>
      <ButtonLink {...props} />
    </GenericAddQueryToHref>
  )
}

export default ButtonWithQueryForwarding
